
const getters = {
  monitoring: state => state.log.monitoring,
  userList: state => state.user.userList,
  statusList: state => state.statusList.statusList,
  afterSales: state => state.afterSales.afterSales,
  pageRouter: state => state.pageRouter.cachedPages,
  downLoadStatus: state => state.downLoadStatus.downLoadStatus,
}
export default getters
